'use client'

import { useEffect } from 'react'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  orderEmailClickEvent,
  OrderEmailClickTarget,
} from '@marketplace-web/order-emails/order-emails-tracking-data'

const validTargets: Array<OrderEmailClickTarget> = [
  'factory_reset',
  'how_to_pack_and_ship',
  'electronic_verification_service',
]

const HelpCenterFaqEntryEmailTrackingEvent = () => {
  const { click_target, transaction_id } = useBrowserNavigation().searchParams

  const { track } = useTracking()

  useEffect(() => {
    if (typeof transaction_id !== 'string' || typeof click_target !== 'string') return

    if (validTargets.includes(click_target as OrderEmailClickTarget)) {
      track(
        orderEmailClickEvent({
          transactionId: transaction_id,
          target: click_target as OrderEmailClickTarget,
        }),
      )
    }
  }, [transaction_id, click_target, track])

  return null
}

export default HelpCenterFaqEntryEmailTrackingEvent
